import { Title, TitleContainer } from './styled';

type ThankYouProps = {
  text: string;
};

export const ThankYou = ({ text }: ThankYouProps) => {
  return (
    <TitleContainer>
      <Title>
        Thank you! We added <br /> {text} for you 💝
      </Title>
    </TitleContainer>
  );
};
